/**
 * Auth branding component
 * Left side panel with AI-themed branding and features
 */

import { Sparkles } from 'lucide-react';

import { AuroraBackground } from '@/components/layout/AuroraBackground/AuroraBackground';
import { Heading } from '@/components/typography/Heading/Heading';
import { Text } from '@/components/typography/Text/Text';
import { useTranslation } from '@/lib/i18n/hooks/use-translation';

import { AuthFeatures } from './AuthFeatures';
import './AuthBranding.scss';

export function AuthBranding() {
  const { t } = useTranslation('auth');

  return (
    <AuroraBackground className="auth-route-branding">
      <div className="auth-route-branding-content">
        <div className="auth-route-logo">
          <div className="auth-route-logo-glow"></div>
          <Sparkles size={48} className="auth-route-logo-icon" />
          <div className="auth-route-logo-pulse"></div>
        </div>

        <Heading level={1} className="auth-route-branding-title">
          {t('branding.title')}
        </Heading>
        <Text className="auth-route-branding-subtitle" size="lg" as="div">
          {t('branding.subtitle')}
        </Text>

        <AuthFeatures />
      </div>
    </AuroraBackground>
  );
}
